"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const _Block = require("@ipld/block");
exports.Block = _Block;
//# sourceMappingURL=ipld.js.map